import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT || "development",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance: 20% of transactions in production
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  // Session Replay: 10% of sessions, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Send traces to our API for distributed tracing
  tracePropagationTargets: ["localhost", /^https:\/\/app\.yieldinnovations\.com/],
});
